import React, { useState } from "react"
import { IoMdPlay } from "react-icons/io";

export default function VideoSection() {
    const [isPlaying, setIsPlaying] = useState(false);

    return (
        <section className="flex flex-col text-center scale-x-110 bg-[#0B0C10] text-white py-20 ">
            <h2 className="uppercase font-bold text-3xl">Amet etiam consequat eget sem sit. <br />Proin Maecenas.</h2>
            <p className="mt-4 text-gray-400 md:w-[57%] md:mx-auto">Chez nous, tu choisis ce qui te plait! Prends render-vous pour une séance d'essai avec un coach trop sympa qui te guidera parmi nos équipements high tech et/ou pour un cours collectif qui donne la peche</p>
            <div className="flex mt-7 justify-center">
                {
                    !isPlaying? (
                        <div className="relative w-[1000px] h-[600px]">
                            <img src="/forvideo.png" alt="la video" className="w-full h-full object-cover" />
                            <button className="absolute inset-0 flex items-center justify-center" onClick={() => setIsPlaying(true)}>
                                <span className="flex item-center justify-center bg-white border-[10px] border-[#ffffff8] w-[100px] h-[100px] rounded-full text-xl hover:scale-105 transition">
                                    <IoMdPlay className="mt-7 text-2xl text-lime-400 "/>
                                </span>
                            </button>
                        </div>
                    ) : (
                        <video className="w-[1000px] h-[600px] rounded-xl" autoPlay controls>
                            <source src="/lavideo.mp4" type="video/mp4"/>
                        </video>
                    )
                }
            </div>
        </section>
    )
}